import styled from 'styled-components';

export const DividerContainer = styled.div`
  margin: ${props => props.theme.spacing(0, 12, 0, 10)};
  display: inline-block;
`;

export const InnerDivider = styled.div`
  width: 1px;
  position: relative;
  top: 10%;
  opacity: 0.25;
  height: 80%;
  justify-content: center;
  border-left: 1px solid ${props => props.theme.colors.text.tertiary};
`;
